import {getDocument} from "../redux/actions/documents/documentsActions";
import {closeModal, setModal} from "../redux/actions/app/appActions";
import {POPUPS} from "../redux/actions/app/appActionTypes";

const downloadDocumentByUrl = async (data, fileName, projectData, dispatch) => {
    dispatch(setModal(POPUPS.PREPARING_POPUP));
    const { path, expired_at } = data;
    const currentTime = Math.floor(Date.now() / 1000);

    if (currentTime > expired_at) {
        const responseDoc = await dispatch(getDocument(projectData.projectId, projectData.documentId));
        const filePath = responseDoc?.payload?.data?.data?.file?.path;

        if (filePath) {
            const res = await fetch(filePath);
            const blob = await res.blob();
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            link.remove();
            URL.revokeObjectURL(url);
            dispatch(closeModal())
        }

        return;
    }

    try {
        const res = await fetch(path);
        const blob = await res.blob();
        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);
        dispatch(closeModal())
    } catch (err) {
        console.error("Failed to download file:", err);
        dispatch(closeModal())
    }
}

const viewOrDownloadDocumentByUrl = async (data, fileName, projectData, dispatch) => {
    dispatch(setModal(POPUPS.PREPARING_POPUP));
    const {path, expired_at} = data;

    const supportedPreviewFormats = ['pdf', 'png', 'jpg', 'jpeg', 'gif'];
    const fileExtension = fileName.split('.').pop().toLowerCase();
    const currentTime = Math.floor(Date.now() / 1000);

    let fileUrl = path;

    if (currentTime > expired_at) {
        const responseDoc = await dispatch(getDocument(projectData.projectId, projectData.documentId));
        const filePath = responseDoc?.payload?.data?.data?.file?.path;

        if (filePath) {
            fileUrl = filePath;
        }
    }

    if (supportedPreviewFormats.includes(fileExtension)) {
        window.open(fileUrl, '_blank');
        dispatch(closeModal())
    } else {
        try {
            const res = await fetch(fileUrl);
            const blob = await res.blob();
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            link.remove();

            URL.revokeObjectURL(url);
            dispatch(closeModal())

        } catch (err) {
            console.error('Ошибка при скачивании файла:', err);
            dispatch(closeModal())

        }
    }
};

export const downloadHandlerFiles = (data, dispatch) => {
    const {
        file, name, docId,projectId
    } = data
    downloadDocumentByUrl(file, name, {
        projectId: projectId,
        documentId: docId
    }, dispatch)
};

export const viewHandlerFiles = (data, dispatch) => {
    const {
        file, name, docId,projectId
    } = data

    viewOrDownloadDocumentByUrl(file, name, {
        projectId: projectId,
        documentId: docId
    }, dispatch)
}

export function isFileTooLarge(fileSizeBytes, maxSizeMB = 20) {
    const maxSizeBytes = maxSizeMB * 1024 * 1024;
    return fileSizeBytes >= maxSizeBytes;
}
